import React from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import { Card, CardHeader, CardContent } from '@mui/material'; // Updated import for MUI v5

const faqContent = [
    { question: "When is the contest starting?", answer: "The start date will be communicated later." },
    { question: "Which online problem-solving platform is best to utilize in preparing for the competition?", answer: "You can use Codeforces and specifically the Codeforces Gym section, which has many past problems from ICPC contests worldwide. Another good resource is Kattis, which also has problems from previous ICPC World Finals." },
    { question: "What type of questions should we expect?", answer: "Expect competitive programming problems." },
    { question: "Where will the competition be held, and how long will it last?", answer: "The competition should be held at the National Mathematical Centre (NMC) in Abuja. Any changes will be shared in the chat. The contest typically lasts for 5 hours." },
    { question: "Will the competition be virtual or physical?", answer: "The competition will be physical." },
    { question: "How will teams collaborate?", answer: "Each team works together to solve the problems." },
    { question: "Will there be internet access during the challenge?", answer: "Internet access will be limited, but participants will have access to documentation for the allowed programming languages." },
    { question: "What are the criteria for forming teams?", answer: "Each team member must be from the same university and eligible to participate (typically undergrad or grad students). Team members can use different programming languages, as long as they are among the languages allowed for the contest." },
    { question: "Which programming languages are allowed in the contest?", answer: "The allowed languages will be communicated closer to the event." },
    { question: "Is DSA (Data Structures and Algorithms) an area of focus for the competition?", answer: "Yes, DSA is one of the areas of focus." },
    { question: "Should the teams be from the same university or a mix of several?", answer: "Teams must be from the same university." }
];

const FaqData = () => (
    <div className="faq-section">
        {faqContent.map((item, index) => (
            <Card key={index} className="faq-item">
                <CardHeader title={item.question} />
                <CardContent>
                    <hr style={{ margin: '1px 0', borderWidth: '1px', border: '1px solid' }} />
                    <p>{item.answer}</p>
                </CardContent>
            </Card>
        ))}
    </div>
);

const Faq = () => {
    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="flex-grow p-4">
                {/* FAQ Section */}
                <FaqData />
            </div>
            <CustomFooter />
        </div>
    );
};

export default Faq;
